import React, { useState, useEffect, useMemo } from 'react';
import authService from '../../api-authorization/AuthorizeService';
import axios from 'axios';
import "bootstrap/dist/css/bootstrap.min.css"; //https://www.creative-tim.com/blog/web-design/how-to-use-bootstrap-with-reactjs/
import BootstrapSwitchButton from 'bootstrap-switch-button-react'
import { ThreeDots } from "react-loader-spinner";
import MUIDataTable, { ExpandButton } from "mui-datatables";
import { createTheme, ThemeProvider, useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import PGNViewer from '../../PGNViewer';
import Modal from '@mui/material/Modal';
import PreviewIcon from '@mui/icons-material/Preview';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import FormLabel from "@mui/material/FormLabel";
import Stack from '@mui/material/Stack';
import LoadingButton from '@mui/lab/LoadingButton';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import RefreshIcon from '@mui/icons-material/Refresh';
import ClearAllIcon from '@mui/icons-material/ClearAll';
import AttachEmailIcon from '@mui/icons-material/AttachEmail';
import { Link, useLocation } from 'react-router-dom'
import { useHistory } from 'react-router-dom'
import { ApplicationPaths } from '../../api-authorization/ApiAuthorizationConstants';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl'
import Checkbox from '@mui/material/Checkbox';
import { Bars, MagnifyingGlass } from "react-loader-spinner";
import { trackPromise } from 'react-promise-tracker';
import { usePromiseTracker } from "react-promise-tracker";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import Moment from 'moment';
import Typography from '@mui/material/Typography';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

const muiCache = createCache({
    key: 'mui-datatables',
    prepend: true,
});

export default function GamesByPlayerId({ idType, id }) {
const muiTheme = useTheme();
const isMobile = useMediaQuery(muiTheme.breakpoints.down('sm'));
    
const [isAdmin, setIsAdmin] = useState(false);
const [status, setStatus] = useState();
const [openErrorDialog, setOpenErrorDialog] = useState(false);
const { promiseInProgress } = usePromiseTracker();
const [statusColor, setStatusColor] = useState();
const [playerId, setPlayerId] = useState(id);
/*const [idType, setIdType] = useState(playerIdType);*/
const [player, setPlayer] = useState();
const [playerName, setPlayerName] = useState("");
const [token, setToken] = useState();
const [authenticated, setAuthenticated] = useState(false);
const [isSupporter, setIsSupporter] = useState(false);
const [waiting, setWaiting] = useState(false);
const [allGames, setAllGames] = useState([]); // Store all games from API
const [games, setGames] = useState([]); // Filtered games for display
const [gameCount, setGameCount] = useState(0);
const [gamePGNString, setGamePGNString] = useState([]);
const [gameKey, setGameKey] = useState("");
const [open, setOpen] = useState(false);
const [searching, setSearching] = useState(false);
const [downloading, setDownloading] = useState(false);
const [includeGamesOfSameName, setIncludeGamesOfSameName] = useState(false);
const [r, setR] = useState(false);
const [u, setU] = useState(false);
const [excludeBlitzGames, setExcludeBlitzGames] = useState(false);
const [whiteGames, setWhiteGames] = useState(true);
const [blackGames, setBlackGames] = useState(true);
const [expandedRows, setExpandedRows] = useState([]);
const [emailDialogOpen, setEmailDialogOpen] = useState(false);
const [emailSending, setEmailSending] = useState(false);
const [emailResult, setEmailResult] = useState({ success: false, message: '', email: '' });
const loginPath = ApplicationPaths.Login;
    const history = useHistory();
    const returnUrl = window.location.href;
    //const location = useLocation();
    //const returnUrl = location.pathname + location.search;
    //https://www.educative.io/answers/how-to-use-the-uselocation-hook-in-react
    const encodedReturnUrl = encodeURIComponent(returnUrl);
    const screenCenterStyle = { position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)" };
    //{ textAlign: 'center' }; /*https ://github.com/davidhu2000/react-spinners/issues/53*/
    const centerDivStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '20vh'
    }; //https://www.c-sharpcorner.com/blogs/how-to-make-a-div-center-in-screen-in-react-js

    // Helper function to check if a game is a blitz game based on event name
    const isBlitzGame = (game) => {
        if (!game.event) return false;
        const eventLower = game.event.toLowerCase();
        return eventLower.includes('blitz') ||
            eventLower.includes('bullet') ||
            eventLower.includes('rapid');
    };

    // Helper function to check if player is white in the game
    const isPlayerWhite = (game, playerId, idType) => {
        if (idType === 'USCF') {
            return game.whiteUSCFID === parseInt(playerId);
        } else if (idType === 'FIDE') {
            return game.whiteFIDEID === parseInt(playerId);
        }
        return false;
    };

    // Helper function to check if player is black in the game
    const isPlayerBlack = (game, playerId, idType) => {
        if (idType === 'USCF') {
            return game.blackUSCFID === parseInt(playerId);
        } else if (idType === 'FIDE') {
            return game.blackFIDEID === parseInt(playerId);
        }
        return false;
    };

    // Local filtering using useMemo for performance
    const filteredGames = useMemo(() => {
        if (allGames.length === 0) return [];

        let filtered = [...allGames];

        // Filter by blitz games
        if (excludeBlitzGames) {
            filtered = filtered.filter(game => !isBlitzGame(game));
        }

        // Filter by player color
        if (whiteGames && !blackGames) {
            // Only show games where player is white
            filtered = filtered.filter(game => isPlayerWhite(game, id, idType));
        } else if (!whiteGames && blackGames) {
            // Only show games where player is black
            filtered = filtered.filter(game => isPlayerBlack(game, id, idType));
        } else if (!whiteGames && !blackGames) {
            // No games selected
            filtered = [];
        }
        // If both whiteGames and blackGames are true, show all games (no filter needed)

        return filtered;
    }, [allGames, excludeBlitzGames, whiteGames, blackGames, id, idType]);

    // Update games state when filteredGames changes
    useEffect(() => {
        setGames(filteredGames);

        // Update status message
        if (filteredGames.length > 0) {
            setStatusColor("green");
            const y = filteredGames[filteredGames.length - 1].year;
            if (filteredGames.length < gameCount) {
                setStatus(isSupporter
                    ? `${filteredGames.length} games since ${y} are shown (filtered from ${allGames.length}).`
                    : `Only ${filteredGames.length} games since ${y} are shown below. Become a supporter to see all ${gameCount} games.`);
            } else {
                setStatus(`${filteredGames.length} games since ${y} are shown.`);
            }
        } else if (allGames.length > 0) {
            setStatusColor("orange");
            setStatus("No games match the current filter criteria.");
        }
    }, [filteredGames, gameCount, isSupporter, allGames.length]);

    // Mobile-friendly expandable row content
    const renderExpandedRow = (rowData, rowMeta) => {
        const game = games[rowMeta.dataIndex];
        if (!game) return null;
        
        const dateStr = (game.year != null ? game.year.toString().padStart(4, '0') : "0000") + "-" + 
                        (game.month != null ? game.month.toString().padStart(2, '0') : "01") + "-" + 
                        (game.day != null ? game.day.toString().padStart(2, '0') : "01");
        
        return (
            <TableRow>
                <TableCell colSpan={6} sx={{ py: 2, px: 2, backgroundColor: '#f5f5f5' }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                            <Box>
                                <Typography variant="caption" color="text.secondary">Date</Typography>
                                <Typography variant="body2">{dateStr}</Typography>
                            </Box>
                            <Box>
                                <Typography variant="caption" color="text.secondary">Result</Typography>
                                <Typography variant="body2">{game.result}</Typography>
                            </Box>
                            <Box>
                                <Typography variant="caption" color="text.secondary">Moves</Typography>
                                <Typography variant="body2">{game.plyCount || '-'}</Typography>
                            </Box>
                        </Box>
                        <Box>
                            <Typography variant="caption" color="text.secondary">Event</Typography>
                            <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>
                                {game.uscfEventId !== -1 ? (
                                    <a href={'http://www.uschess.org/msa/XtblMain.php?' + game.uscfEventId} target='_blank' rel='noreferrer'>{game.event}</a>
                                ) : game.fideEventId !== -1 ? (
                                    <a href={'https://ratings.fide.com/report.phtml?event=' + game.fideEventId} target='_blank' rel='noreferrer'>{game.event}</a>
                                ) : game.event}
                            </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                            <Box>
                                <Typography variant="caption" color="text.secondary">White Elo</Typography>
                                <Typography variant="body2">
                                    {game.whiteUSCFID !== -1 ? (
                                        <a href={'http://www.uschess.org/msa/MbrDtlMain.php?' + game.whiteUSCFID} target='_blank' rel='noreferrer'>{game.whiteElo}</a>
                                    ) : game.whiteElo}
                                </Typography>
                            </Box>
                            <Box>
                                <Typography variant="caption" color="text.secondary">Black Elo</Typography>
                                <Typography variant="body2">
                                    {game.blackUSCFID !== -1 ? (
                                        <a href={'http://www.uschess.org/msa/MbrDtlMain.php?' + game.blackUSCFID} target='_blank' rel='noreferrer'>{game.blackElo}</a>
                                    ) : game.blackElo}
                                </Typography>
                            </Box>
                        </Box>
                        {authenticated && (
                            <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
                                <Button 
                                    variant="outlined" 
                                    size="small"
                                    onClick={async (e) => { await viewGame(e, game.gameHash) }}
                                    startIcon={<PreviewIcon />}
                                >
                                    Preview
                                </Button>
                                <Button 
                                    component={Link} 
                                    target="_blank" 
                                    to={'/games/GameByID/' + game.gameHash} 
                                    variant="contained" 
                                    color="primary"
                                    size="small"
                                >
                                    View Game
                                </Button>
                            </Box>
                        )}
                    </Box>
                </TableCell>
            </TableRow>
        );
    };

    // Define columns based on screen size
    const getColumns = () => {
        if (isMobile) {
            // Mobile: Show minimal columns with expand for more details
            // Column width percentages: #=8%, Event=36%, White=24%, R=8%, Black=24%
            return [
                {
                    name: '',
                    label: '#',
                    options: {
                        filter: false,
                        sort: false,
                        setCellHeaderProps: () => ({ style: { textAlign: 'center', padding: '2px' } }),
                        setCellProps: () => ({ style: { width: '8%', padding: '2px', textAlign: 'center', boxSizing: 'border-box' } }),
                        customBodyRender: (value, tableMeta) => {
                            return <span style={{ fontSize: '9px', color: '#666' }}>{tableMeta.rowIndex + 1}</span>;
                        }
                    }
                },
                {
                    name: "event",
                    label: "Event",
                    options: {
                        filter: false,
                        sort: true,
                        setCellHeaderProps: () => ({ style: { textAlign: 'left' } }),
                        setCellProps: () => ({ style: { width: '36%', padding: '4px 2px', overflow: 'hidden', boxSizing: 'border-box' } }),
                        customBodyRender: (value, tableMeta) => {
                            let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                            let game = games[originalIndex];
                            const dateStr = (game.year != null ? game.year.toString() : "????") + "-" + 
                                           (game.month != null ? game.month.toString().padStart(2, '0') : "??") + "-" + 
                                           (game.day != null ? game.day.toString().padStart(2, '0') : "??");
                            
                            return (
                                <div style={{ display: 'flex', flexDirection: 'column', gap: 0, overflow: 'hidden', width: '100%' }}>
                                    <div style={{ fontSize: '10px', fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', lineHeight: 1.2 }} title={value}>
                                        {value}
                                    </div>
                                    <div style={{ fontSize: '9px', color: '#666', lineHeight: 1 }}>
                                        [{dateStr}]
                                    </div>
                                </div>
                            );
                        }
                    }
                },
                {
                    name: "white",
                    label: "White",
                    options: {
                        filter: false,
                        sort: true,
                        setCellHeaderProps: () => ({ style: { textAlign: 'right' } }),
                        customHeadLabelRender: (columnMeta) => (
                            <div style={{ textAlign: 'right', width: '100%' }}>{columnMeta.label}</div>
                        ),
                        setCellProps: () => ({ style: { width: '24%', padding: '4px 2px', textAlign: 'right', overflow: 'hidden', boxSizing: 'border-box' } }),
                        customBodyRender: (value, tableMeta) => {
                            let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                            let game = games[originalIndex];
                            const rating = game.whiteElo || '';
                            
                            return (
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', overflow: 'hidden', width: '100%' }}>
                                    <div style={{ fontSize: '10px', fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', lineHeight: 1.2, textAlign: 'right', width: '100%' }} title={value}>
                                        {game.whiteFIDEID !== -1 ? (
                                            <a href={'https://ratings.fide.com/profile/' + game.whiteFIDEID} target='_blank' rel='noreferrer'>{value}</a>
                                        ) : value}
                                    </div>
                                    {rating > 0 && (
                                        <div style={{ fontSize: '9px', color: '#666', lineHeight: 1 }}>
                                            [{rating}]
                                        </div>
                                    )}
                                </div>
                            );
                        }
                    }
                },
                {
                    name: "result",
                    label: "R",
                    options: {
                        filter: true,
                        filterType: 'multiselect',
                        sort: true,
                        setCellHeaderProps: () => ({ style: { textAlign: 'center' } }),
                        customHeadLabelRender: (columnMeta) => (
                            <div style={{ textAlign: 'center', width: '100%' }}>{columnMeta.label}</div>
                        ),
                        setCellProps: () => ({ style: { width: '8%', padding: '4px 2px', textAlign: 'center', boxSizing: 'border-box' } }),
                        customBodyRender: (value, tableMeta) => {
                            let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                            let game = games[originalIndex];
                            if (authenticated) {
                                return (
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <Link target="_blank" to={'/games/GameByID/' + game.gameHash} style={{ fontSize: '10px', fontWeight: 600 }}>{value}</Link>
                                    </div>
                                );
                            }
                            return <span style={{ fontSize: '10px', fontWeight: 600, display: 'block', textAlign: 'center' }}>{value}</span>;
                        }
                    }
                },
                {
                    name: "black",
                    label: "Black",
                    options: {
                        filter: false,
                        sort: true,
                        setCellHeaderProps: () => ({ style: { textAlign: 'left' } }),
                        setCellProps: () => ({ style: { width: '24%', padding: '4px 2px', textAlign: 'left', overflow: 'hidden', boxSizing: 'border-box' } }),
                        customBodyRender: (value, tableMeta) => {
                            let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                            let game = games[originalIndex];
                            const rating = game.blackElo || '';
                            
                            return (
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', overflow: 'hidden', width: '100%' }}>
                                    <div style={{ fontSize: '10px', fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', lineHeight: 1.2, textAlign: 'left', width: '100%' }} title={value}>
                                        {game.blackFIDEID !== -1 ? (
                                            <a href={'https://ratings.fide.com/profile/' + game.blackFIDEID} target='_blank' rel='noreferrer'>{value}</a>
                                        ) : value}
                                    </div>
                                    {rating > 0 && (
                                        <div style={{ fontSize: '9px', color: '#666', lineHeight: 1 }}>
                                            [{rating}]
                                        </div>
                                    )}
                                </div>
                            );
                        }
                    }
                }
            ];
        }
        
        // Desktop: Full columns
        return [
        {
            name: '',
            label: '',
            options: {
                filter: false,
                display: true,
                viewColumns: false,
                setCellProps: () => ({ style: { whiteSpace: "nowrap", textAlign: "right", textOverflow: "ellipsis", overflow: "hidden" } }), //minWidth: "40px", maxWidth: "40px",
                customBodyRender: (value, tableMeta, updateValue) => {
                    let rowIndex = Number(tableMeta.rowIndex) + 1;
                    let parentStyle = {
                        boxSizing: "border-box",
                        display: "block",
                        width: "100%"
                    };
                    let cellStyle = {
                        boxSizing: "border-box",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                    };
                    return (
                        <div style={parentStyle}>
                            <div style={cellStyle} title={rowIndex}>
                                {rowIndex}
                            </div>
                        </div>
                    )

                }
            },
        },
        {
            name: 'year',
            label: 'Year',
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                display: false,
                viewColumns: true,
                setCellProps: () => ({ style: { whiteSpace: "nowrap" } })
            },
        },
        {
            name: 'month',
            label: 'Month',
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                display: false,
                viewColumns: true,
                setCellProps: () => ({ style: { whiteSpace: "nowrap" } }),
            },
        },
        {
            name: 'day',
            label: 'Day',
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                display: false,
                viewColumns: true,
                setCellProps: () => ({ style: { whiteSpace: "nowrap" } }),
            },
        },

        {
            name: "date",
            label: "Date",
            options: {
                filter: false,
                sort: true,
                sortThirdClickReset: true,
                setCellProps: () => ({ style: { whiteSpace: "nowrap", textAlign: "left", minWidth: "40px", maxWidth: "40px", textOverflow: "ellipsis", overflow: "hidden" } }),

                //setCellProps: () => ({ style: { whiteSpace: "nowrap", textAlign: "left" } }),
                //customLabelHeadRender: (columnMeta, updateDirection) => (
                //    <th key={2} onClick={() => updateDirection(2)} style={{ textAlign: "center", whiteSpace: "nowrap", width: "20px" }}>
                //        {columnMeta.label}
                //    </th>
                //),
                setCellProps: () => ({ style: { whiteSpace: "nowrap", textAlign: "left", textOverflow: "ellipsis", overflow: "hidden" } }),//minWidth: "40px", maxWidth: "40px",
                customBodyRender: (value, tableMeta, updateValue) => {
                    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    let game = games[originalIndex];
                    let dateStr = (game.year != null ? game.year.toString().padStart(4, '0') : "0000") + "-" + (game.month != null ? game.month.toString().padStart(2, '0') : "01") + "-" + (game.day != null ? game.day.toString().padStart(2, '0') : "01");
                    let tenDaysAgo = Moment(dateStr, 'YYYY-MM-DD').add(-10, 'days').format("YYYY-MM-DD");
                    let tenDaysLater = Moment(dateStr, 'YYYY-MM-DD').add(10, 'days').format("YYYY-MM-DD");
                    let parentStyle = {
                        boxSizing: "border-box",
                        display: "block",
                        width: "100%"
                    };
                    let cellStyle = {
                        boxSizing: "border-box",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                    };
                    if (authenticated && isAdmin) {
                        return (
                            <div style={parentStyle} >
                                <div style={cellStyle} title={value}>
                                    <Link target="_blank" to={'/EventGames/Update?eventName=' + encodeURIComponent(game.event) + '&eventStartDate=' + tenDaysAgo + '&eventEndDate=' + tenDaysLater}> {dateStr} </Link>
                                </div>
                            </div>
                        )
                    }
                    else {
                        return (
                            <div style={parentStyle} >
                                <div style={cellStyle} title={value}>
                                    {dateStr}
                                </div>
                            </div>
                        )
                    }

                    //customBodyRender: (value, tableMeta, updateValue) => {
                    //    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    //    let game = games[originalIndex];
                    //    let dateStr = (game.year != null ? game.year.toString().padStart(4, '0') : "0000") + "-" + (game.month != null ? game.month.toString().padStart(2, '0') : "01") + "-" + (game.day != null ? game.day.toString().padStart(2, '0') : "01");
                    //    let tenDaysAgo = Moment(dateStr, 'YYYY-MM-DD').add(-10, 'days').format("YYYY-MM-DD");
                    //    let tenDaysLater = Moment(dateStr, 'YYYY-MM-DD').add(10, 'days').format("YYYY-MM-DD");

                    //    if (authenticated) {
                    //        return (
                    //            <div> <Link target="_blank" to={'/EventGames/Update?eventName=' + game.event + '&eventStartDate=' + tenDaysAgo + '&eventEndDate=' + tenDaysLater}> {dateStr} </Link></div>
                    //        )
                    //    }
                    //    else {
                    //        return (
                    //            <div>{dateStr} </div>
                    //        )
                    //    }
                },
                sortCompare: (order) => {
                    return (obj1, obj2) => {
                        let val1 = Date.parse(obj1.data);
                        let val2 = Date.parse(obj2.data);
                        return (val1 - val2) * (order === 'asc' ? 1 : -1);
                    };
                }
            }
        },
        {
            name: "event",
            label: "Event",
            options: {
                filter: true,
                filterType: 'multiselect',
                display: authenticated,
                sort: true,
                sortThirdClickReset: true,
                setCellProps: () => ({ style: { whiteSpace: "nowrap", textAlign: "left", minWidth: "200px", maxWidth: "200px", textOverflow: "ellipsis", overflow: "hidden" } }),
                customBodyRender: (value, tableMeta, updateValue) => {
                    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    let game = games[originalIndex];
                    let parentStyle = {
                        boxSizing: "border-box",
                        display: "block",
                        width: "100%"
                    };
                    let cellStyle = {
                        boxSizing: "border-box",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                    };
                    return (
                        <div style={parentStyle}>
                            <div style={cellStyle} title={value}>
                                {game.uscfEventId !== -1 ? (<a href={'http://www.uschess.org/msa/XtblMain.php?' + game.uscfEventId} target='_blank' rel='noreferrer'>{value}</a>) :
                                    (game.fideEventId !== -1 ? (<a href={'https://ratings.fide.com/report.phtml?event=' + game.fideEventId} target='_blank' rel='noreferrer'>{value}</a>) :
                                        (value == 'Please Support MetaDB' ? (<Link target="_blank" to={'/SupporterDonate'} >{value}</Link>) : value)
                                    )}
                            </div>
                        </div>
                    );
                    //return (
                    //    /*style={cellStyle}*/
                    //    <span title={value}>
                    //                {game.uscfEventId !== -1 ? (<a href={'http://www.uschess.org/msa/XtblMain.php?' + game.uscfEventId} target='_blank' rel='noreferrer'>{value}</a>) :
                    //                    (game.fideEventId !== -1 ? (<a href={'https://ratings.fide.com/report.phtml?event=' + game.fideEventId} target='_blank' rel='noreferrer'>{value}</a>) : value)}
                    //    </span>
                    //);
                }
            }
        },
        {
            name: "whiteElo",
            label: "WElo",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                /*setCellProps: () => ({ style: { whiteSpace: "nowrap", width: "40px" } }),*/
                //setCellProps: () => ({ style: { whiteSpace: "nowrap", textAlign: "left" } }),
                setCellProps: () => ({ style: { whiteSpace: "nowrap", textAlign: "left", textOverflow: "ellipsis", overflow: "hidden" } }),//minWidth: "15px", maxWidth: "15px",
                //customLabelHeadRender: (columnMeta, updateDirection) => (
                //    <div key={2} onClick={() => updateDirection(2)} style={{ textAlign: "right", whiteSpace: "nowrap", width: "40px" }}>
                //        {columnMeta.label}
                //    </div>
                //),
                customBodyRender: (value, tableMeta, updateValue) => {
                    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    let game = games[originalIndex];
                    let parentStyle = {
                        boxSizing: "border-box",
                        display: "block",
                        width: "100%"
                    };
                    let cellStyle = {
                        boxSizing: "border-box",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                    };

                    return (
                        <div style={parentStyle}>
                            <div style={cellStyle} title={value}>{game.whiteUSCFID !== -1 ? <a href={'http://www.uschess.org/msa/MbrDtlMain.php?' + game.whiteUSCFID} target='_blank' rel='noreferrer'>{value}</a> : value}</div>
                        </div>


                        /*<span title={ value}>{game.whiteUSCFID !== -1 ? <a href={'http://www.uschess.org/msa/MbrDtlMain.php?' + game.whiteUSCFID} target='_blank' rel='noreferrer'>{value}</a> : value}</span>*/

                    );
                }
            }
        },
        {
            name: "white",
            label: "White",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                setCellHeaderProps: () => ({ style: { align: "right" } }),
                /*setCellHeaderProps: () => { return { align: "right" } },*/
                //customLabelHeadRender: (columnMeta, updateDirection) => (
                //    <span style={{ textAlign: "right", whiteSpace: "nowrap" }}>
                //        {columnMeta.label}
                //    </span>
                //    ),
                customLabelHeadRender: (columnMeta, updateDirection) => (
                    <div style={{ textAlign: "right", whiteSpace: "nowrap" }}>
                        {columnMeta.label}
                    </div>
                ),
                setCellProps: () => ({ style: { whiteSpace: "nowrap", textAlign: "left", minWidth: "140px", maxWidth: "140px", overflow: "hidden", textOverflow: "ellipsis", } }),
                customBodyRender: (value, tableMeta, updateValue) => {
                    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    let game = games[originalIndex];
                    let parentStyle = {
                        boxSizing: "border-box",
                        display: "block",
                        width: "100%"
                    };
                    let cellStyle = {
                        boxSizing: "border-box",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                    };

                    return (
                        <div style={parentStyle}>
                            <div style={cellStyle} title={value}>{game.whiteFIDEID !== -1 ? <a href={'https://ratings.fide.com/profile/' + game.whiteFIDEID} target='_blank' rel='noreferrer'>{value}</a> : value}</div>
                        </div>
                        //</div> style={cellStyle}
                        //<span  title={value}>{game.whiteFIDEID !== -1 ? <a href={'https://ratings.fide.com/profile/' + game.whiteFIDEID} target='_blank' rel='noreferrer'>{value}</a> : value}</span>
                    );
                }
            }
        },
        {
            name: "result",
            label: "Result",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                customLabelHeadRender: (columnMeta, updateDirection) => (
                    <div style={{ textAlign: "center", whiteSpace: "nowrap" }}>{columnMeta.label}</div>
                ),
                //setCellProps: () => ({ style: { whiteSpace: "nowrap", textAlign: "left" } }),
                setCellProps: () => ({ style: { whiteSpace: "nowrap", textAlign: "left", overflow: "hidden", textOverflow: "ellipsis" } }),//minWidth: "40px", maxWidth: "40px",
                customBodyRender: (value, tableMeta, updateValue) => {
                    if (authenticated) {
                        let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                        let game = games[originalIndex];
                        //return (
                        //    <div style={{ textAlign: "left" }} onClick={async (e) => { await viewGame(e, game.gameHash) }}> <PreviewIcon />{value}</div>
                        //);
                        return (
                            <div>
                                {/*<span style={{ textAlign: "left" }} onClick={async (e) => { await viewGame(e, game.gameHash) }}> <PreviewIcon /></span>*/}
                                {/*<Button component={Link} target="_blank" to={'/games/GameByID/' + game.gameHash} variant="text" color="primary">*/}
                                {/*    {value}*/}
                                {/*</Button>*/}
                                <span style={{ textAlign: "left" }} onClick={async (e) => { await viewGame(e, game.gameHash) }}> <PreviewIcon /></span>
                                <Link target="_blank" to={'/games/GameByID/' + game.gameHash} >{value}</Link>
                            </div>

                        );
                    }
                    else {
                        return (
                            <div style={{ textAlign: "center" }}> {value}</div>
                        );
                    }

                }
            }
        },
        {
            name: "black",
            label: "Black",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                //customLabelHeadRender: (columnMeta, updateDirection) => (
                //    <th key={2} onClick={() => updateDirection(2)} style={{ textAlign: "left", whiteSpace: "nowrap", width: "100px" }}>
                //        {columnMeta.label}
                //    </th>
                //),
                //setCellProps: () => ({ style: { whiteSpace: "nowrap", textAlign: "left", minWidth: "100px", maxWidth: "100px", overflow: "hidden", textOverflow: "ellipsis", boxSizing: "border-box", } }),
                setCellProps: () => ({ style: { whiteSpace: "nowrap", textAlign: "left", minWidth: "140px", maxWidth: "140px", overflow: "hidden", textOverflow: "ellipsis", } }),
                customBodyRender: (value, tableMeta, updateValue) => {
                    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    let game = games[originalIndex];
                    let parentStyle = {
                        boxSizing: "border-box",
                        display: "block",
                        width: "100%"
                    };
                    let cellStyle = {
                        boxSizing: "border-box",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                    };

                    return (
                        <div style={parentStyle}>
                            <div title={value} style={cellStyle}>{game.blackFIDEID != -1 ? <a href={'https://ratings.fide.com/profile/' + game.blackFIDEID} target='_blank' rel='noreferrer'>{value}</a> : value}</div>
                        </div>
                        //<span style={cellStyle} title={value} >{game.blackFIDEID != -1 ? <a href={'https://ratings.fide.com/profile/' + game.blackFIDEID} target='_blank' rel='noreferrer'>{value}</a> : value}</span>
                    );
                }
            }
        },
        {
            name: "blackElo",
            label: "BElo",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                //setCellProps: () => ({ style: { whiteSpace: "nowrap", textAlign: "left" } }),
                setCellProps: () => ({ style: { whiteSpace: "nowrap", textAlign: "left", textOverflow: "ellipsis", overflow: "hidden" } }), //minWidth: "15px", maxWidth: "15px",
                //customLabelHeadRender: (columnMeta, updateDirection) => (
                //    <th key={2} onClick={() => updateDirection(2)} style={{ textAlign: "left", whiteSpace: "nowrap", width: "20px" }}>
                //        {columnMeta.label}
                //    </th>
                //),
                customBodyRender: (value, tableMeta, updateValue) => {
                    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    let game = games[originalIndex];
                    let parentStyle = {
                        boxSizing: "border-box",
                        display: "block",
                        width: "100%"
                    };
                    let cellStyle = {
                        boxSizing: "border-box",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                    };

                    return (
                        <div style={parentStyle}>
                            <div style={cellStyle} title={value}>{game.blackUSCFID !== -1 ? <a href={'http://www.uschess.org/msa/MbrDtlMain.php?' + game.blackUSCFID} target='_blank' rel='noreferrer'>{value}</a> : value}</div>
                        </div>
                        //</div>
                        //<span title={value}>{game.blackUSCFID !== -1 ? <a href={'http://www.uschess.org/msa/MbrDtlMain.php?' + game.blackUSCFID} target='_blank' rel='noreferrer'>{value}</a> : value}</span>
                    );
                }
            }
        },
        {
            name: "plyCount",
            label: "Play",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                display: true,
                viewColumns: true,
                //setCellProps: () => ({ style: { whiteSpace: "nowrap", textAlign: "left" } }),
                setCellProps: () => ({ style: { whiteSpace: "nowrap", textAlign: "left", textOverflow: "ellipsis", overflow: "hidden" } }), //minWidth: "15px", maxWidth: "15px",
                //customLabelHeadRender: (columnMeta, updateDirection) => (
                //    <th key={2} onClick={() => updateDirection(2)} style={{ textAlign: "left", whiteSpace: "nowrap" }}>
                //        {columnMeta.label}
                //    </th>
                //)
            }
                }
            ];
            };

            const columns = getColumns();

            const options = {
                setTableProps: () => ({
                    size: 'small',
                    style: isMobile ? { tableLayout: 'fixed', width: '100%' } : {},
                }),
                setCellProps: (cellValue, cellMeta) => {
                    // Make expand button column (colIndex 0) tiny
                    if (isMobile && cellMeta && cellMeta.colIndex === 0) {
                        return { style: { width: 12, minWidth: 12, maxWidth: 12, padding: '0 1px', textAlign: 'center' } };
                    }
                    return {};
                },
                setCellHeaderProps: (column) => {
                    // Make expand button header cell tiny
                    if (isMobile && column.index === 0) {
                        return { style: { width: 12, minWidth: 12, maxWidth: 12, padding: '0 1px', textAlign: 'center' } };
                    }
                    return {};
                },
                draggableColumns: {
                    enabled: !isMobile
                },
                fixedHeader: true,
                resizableColumns: !isMobile,
                filter: !isMobile,
                filterType: 'dropdown',
                responsive: isMobile ? 'standard' : 'standard',
                selectableRows: 'none',
                download: false,
                print: false,
                viewColumns: !isMobile,
                search: !isMobile,
                rowsPerPage: isMobile ? 50 : 200,
                rowsPerPageOptions: isMobile ? [50, 100, 200] : [5, 10, 15, 20, 25, 50, 100, 200],
                jumpToPage: !isMobile,
                expandableRows: isMobile,
                expandableRowsOnClick: isMobile,
                expandableRowsHeader: false,
                renderExpandableRow: isMobile ? renderExpandedRow : undefined,
                setRowProps: (row, index) => ({ style: { backgroundColor: index % 2 === 1 ? '' : "#F5F5F5", cursor: 'pointer' } }),
                isRowExpandable: (dataIndex, expandedRows) => {
                    if (expandedRows.data.length > 4 && expandedRows.data.filter(d => d.dataIndex === dataIndex).length === 0)
                        return false;
                    return true;
                },
                rowsExpanded: expandedRows,
                onRowExpansionChange: (curExpanded, allExpanded, rowsExpanded) => {
                    setExpandedRows(allExpanded.map(r => r.dataIndex));
                },
                textLabels: {
                    body: {
                        noMatch: "No games found",
                    },
                    pagination: {
                        rowsPerPage: isMobile ? "Rows:" : "Rows per page:",
                    },
                },
            };

    const theme = createTheme({
        components: {
            MuiButton: {
                styleOverrides: {
                    root: {
                        fontFamily: 'poppins',
                        fontWeight: 'bold',
                    },
                },
            },
            MuiTableCell: {
                styleOverrides: {
                    root: {
                        padding: isMobile ? '6px 4px' : '16px',
                    },
                },
            },
        },
        overrides: {
            MUIDataTableSelectCell: {
                expandDisabled: {
                    // Soft hide the button.
                    visibility: 'hidden',
                },
            },
        },
    });

    const components = {
        ExpandButton: function (props) {
            return <ExpandButton {...props} />;
        },
    };

    const GetMySupporterStatus = async (token) => {

        //var ttt = authService.getAccessToken();

        var headers = {
            headers: { 'Authorization': `Bearer ${token}` }
        }

        axios.get('/api/NACHUsers/GetMySupporterStatusExpDateUtc', headers).then((response) => {
            setIsSupporter(response.data.isSupporter);
            return response.data.isSupporter;
        }).catch((error) => {
            console.log(JSON.stringify(error));
            setIsSupporter(false);
            return false;
        });
    };

    useEffect(() => {
        async function getEffectData() {
            setAuthenticated(await authService.isAuthenticated());
            var ttt = await authService.getAccessToken();
            await setToken(ttt);

            var user = await authService.getUser();
            if (user != null) {
                var role = user.role;
                if (role.includes("Administrators"))
                    setIsAdmin(true);
            }
            await GetMySupporterStatus(ttt);
            await getPlayerGameCount(idType, id, ttt);
            await findPlayerGames(idType, id, ttt, includeGamesOfSameName, excludeBlitzGames, whiteGames, blackGames, r) //, props.includeGamesOfSameName, props.excludeBlitzGames)
        }
        getEffectData()

    }, [isSupporter, gameCount]); //Runs only on the first render

    //https://stackoverflow.com/questions/41938718/how-to-download-files-with-axios?rq=1

    const downloadPGN = async (e, idType, id, includeGamesOfSameName, excludeBlitzGames, whiteGames, blackGames) => {
        if (!id) {
            e.preventDefault();
            setStatusColor("red");
            setStatus("Error : No ID provided");
            setDownloading(false);
        }
        else {
            e.preventDefault();
            setToken(await authService.getAccessToken());
            var headers = {
                headers: { 'Authorization': `Bearer ${token}` }
            }
            setWaiting(true);
            axios.get('/api/ChessGames/downloadPGN?IDType=' + idType + '&id=' + id + '&includeGamesOfSameName=' + includeGamesOfSameName + '&excludeBlitzGames=' + excludeBlitzGames + '&whiteGames=' + whiteGames + '&blackGames=' + blackGames, headers).then((response) => {
                let responseHeader = response.headers['content-disposition'].split('filename=');
                let fileName = responseHeader[1].split(';')[0];
                let blob = new Blob([response.data]);
                let FileSaver = require('file-saver');
                FileSaver.saveAs(blob, fileName);
                setWaiting(false);
                setDownloading(false);
            }).catch((error) => {
                setDownloading(false);
                setWaiting(false);
                setStatus(error.response.data);
                console.log(error.response.data);
                setOpenErrorDialog(true);
            });
        }

    };

    const refreshPlayerGames = async (e, idType, id, includeGamesOfSameName, excludeBlitzGames, whiteGames, blackGames, r, u) => {
        if (!id) {
            e.preventDefault();
            setStatusColor("red");
            setStatus("Error : No ID provided");
            setDownloading(false);
        }
        else {
            e.preventDefault();
            setWaiting(true);
            setToken(await authService.getAccessToken());
            var headers = {
                headers: { 'Authorization': `Bearer ${token}` }
            }

            axios.get('/api/chessgames/findplayergames?idtype=' + idType + '&id=' + id + '&includeGamesOfSameName=' + includeGamesOfSameName + '&excludeBlitzGames=' + excludeBlitzGames + '&whiteGames=' + whiteGames + '&blackGames=' + blackGames + '&r=' + r + '&u=' + u, headers).then((response) => {
                const playergames = response.data;
                setSearching(false);
                setAllGames(playergames); // Store all games
                setGames(playergames);
                if (playergames.length > 0) {
                    setStatusColor("green");
                } else {
                    setStatusColor("red");
                }

                setWaiting(false);
                setDownloading(false);
                var y = playergames[playergames.length - 1].year;
                setStatus(isSupporter ? playergames.length + " games since " + y + " are found." : "Only " + playergames.length + " games since " + y + " are shown below. Become a MetaDB supporter to see all games.");
            }).catch((error) => {
                setDownloading(false);
                setWaiting(false);
                setStatus(error.response.data);
                console.log(error.response.data);
            });

        }
    };

    const emailPGN = async (e, idType, id, includeGamesOfSameName, excludeBlitzGames, whiteGames, blackGames) => {
        if (!id) {
            e.preventDefault();
            setStatusColor("red");
            setStatus("Error : No ID provided");
            setDownloading(false);
        }
        else {
            e.preventDefault();
            setToken(await authService.getAccessToken());
            var headers = {
                headers: { 'Authorization': `Bearer ${token}` }
            }
            // Open dialog and show sending state
            setEmailSending(true);
            setEmailDialogOpen(true);
            setEmailResult({ success: false, message: '', email: '' });
            
            axios.get('/api/ChessGames/emailPGN?IDType=' + idType + '&id=' + id + '&includeGamesOfSameName=' + includeGamesOfSameName + '&excludeBlitzGames=' + excludeBlitzGames + '&whiteGames=' + whiteGames + '&blackGames=' + blackGames, headers).then((response) => {
                // Handle both string and JSON responses
                const data = response.data;
                const message = typeof data === 'object' ? data.message : data;
                const email = typeof data === 'object' && data.email ? data.email : '';
                
                setEmailSending(false);
                setEmailResult({ success: true, message: message, email: email });
                setStatus(message);
                setStatusColor("green");
                setDownloading(false);
            }).catch((error) => {
                setEmailSending(false);
                const errorMessage = error.response?.data || 'Failed to send email';
                setEmailResult({ success: false, message: errorMessage, email: '' });
                setDownloading(false);
            });
        }

    };

    const handleCloseEmailDialog = () => {
        setEmailDialogOpen(false);
        setEmailSending(false);
    };

    const findPlayerGames = async (idType, id, accessToken, includeGamesOfSameName, excludeBlitzGames, whiteGames, blackGames, r) => {
        if (!id) {
            setStatusColor("red");
            setStatus("Error : No ID provided");
            setSearching(false);
        }
        else {
            var headers = {
                headers: { 'Authorization': `Bearer ${accessToken}` }
            }
            trackPromise(
                axios.get('/api/chessgames/findplayergames?idtype=' + idType + '&id=' + id + '&includeGamesOfSameName=' + includeGamesOfSameName + '&excludeBlitzGames=' + excludeBlitzGames + '&whiteGames=' + whiteGames + '&blackGames=' + blackGames + '&r=' + r, headers).then((response) => {
                    const playergames = response.data;
                    setSearching(false);
                    setAllGames(playergames); // Store all games
                    setGames(playergames);
                    if (playergames.length > 0) {
                        setStatusColor("green");
                    } else {
                        setStatusColor("red");
                    }

                    setWaiting(false);
                    var y = playergames[playergames.length - 1].year;
                    if (playergames.length < gameCount) {
                        setStatus(isSupporter ? playergames.length + " games since " + y + " are found." : "Only " + playergames.length + " games since " + y + " are shown below. Become a supporter to see all " + gameCount + " games the player has in MetaDB.");
                    }
                    else {
                        setStatus(playergames.length + " games since " + y + " are found.");
                    }


                }).catch((error) => {
                    setStatusColor("red");
                    setSearching(false);
                    setStatus(error.response.data);
                    setWaiting(false);
                    console.log(error.response.data);
                })
            )
        }
    };

    const getPlayerGameCount = async (idType, id, accessToken) => {
        if (!id) {
            setStatusColor("red");
            setStatus("Error : No ID provided");
            setSearching(false);
        }
        else {
            var headers = {
                headers: { 'Authorization': `Bearer ${accessToken}` }
            }
            trackPromise(
                axios.get('/api/chessgames/countPlayergames?idtype=' + idType + '&id=' + id, headers).then((response) => {
                    const count = response.data;
                    setSearching(false);
                    setGameCount(count);
                    setWaiting(false);
                }).catch((error) => {
                    setStatusColor("red");
                    setSearching(false);
                    setStatus(error.response.data);
                    setWaiting(false);
                    console.log(error.response.data);
                })
            )
        }
    };
    async function viewGame(e, gameHash) {
        e.preventDefault();
        var headers = {
            headers: { 'Authorization': `Bearer ${token}` }
        }
        setWaiting(true);
        await axios.get('/api/chessgames/getSingleGame?gamehash=' + gameHash, headers).then((response) => {
            const pgnString = response.data;
            setGamePGNString(pgnString);
            setGameKey(gameHash);
            setWaiting(false);
            setOpen(true);
        }).catch((error) => {
            setWaiting(true);
            setStatus(error.response.data);
            console.log(error.response.data);
        });
    };

    const handleClick = () => {
        setOpen(true);
    };

    const handleClose = () => setOpen(false);

    const handleCloseErrorDialog = () => {
        setOpenErrorDialog(false);
    };

    return (

        <div>
            {(promiseInProgress === true) ?
                <Box sx={{ pt: 2, pb: 1 }}>
                    <div style={centerDivStyle}>
                        <MagnifyingGlass ariaLabel="Loading" color="#00BFFF" />
                    </div>
                </Box>
                :
                <Box sx={{ pt: 2, pb: 1, px: isMobile ? 1 : 0 }}>
                    {games.length === 0 &&
                        <Grid item xs={12}>
                            <FormLabel sx={{ color: statusColor, fontSize: isMobile ? '12px' : '14px' }}>
                                {status}
                            </FormLabel>
                        </Grid>
                    }
                    <Grid container direction="row" rowSpacing={1} columnSpacing={1} justifyContent="space-between" alignItems="stretch">
                        {/*<Grid item xs={12} lg={6} >*/}
                        {/*    <span>{ JSON.stringify(props.player)}</span>*/}
                        {/*</Grid>*/}
                        {/*<Grid item xs={12}>*/}
                        {/*    <FormLabel sx={{ color: statusColor }}>*/}
                        {/*        {status}*/}
                        {/*    </FormLabel>*/}
                        {/*</Grid>*/}
                        <Grid item xs={12} lg={6} >
                            {/*<FormLabel sx={{ color: statusColor }}>*/}
                            {/*    {status}*/}
                            {/*    </FormLabel>*/}
                            {/*    <FormGroup>*/}
                            {/*        <FormControlLabel control={<Checkbox disabled={!authenticated} onChange={e => {setExcludeBlitzGames(e.target.checked);}}/>} label="Exclude Blitz Games" />*/}
                            {/*    </FormGroup>*/}
                            {allGames.length > 0 && authenticated &&
                                <FormControl fullWidth sx={{ m: isMobile ? 0 : 1, minWidth: 20 }}>
                                    <FormGroup row={true} sx={{ flexWrap: 'wrap', gap: isMobile ? 0 : 1 }}>
                                        {/*<FormControlLabel sx={{ color: statusColor }}>{status}</FormControlLabel>*/}
                                        {/*<FormControlLabel label={status} />*/}
                                        <FormControlLabel 
                                            control={<Checkbox disabled={!authenticated} checked={excludeBlitzGames} onChange={e => { setExcludeBlitzGames(e.target.checked); }} size={isMobile ? "small" : "medium"} />} 
                                            label={<Typography variant={isMobile ? "caption" : "body2"}>No Blitz</Typography>} 
                                        />
                                        <FormControlLabel 
                                            control={<Checkbox disabled={!authenticated} checked={whiteGames} onChange={e => { setWhiteGames(e.target.checked); }} size={isMobile ? "small" : "medium"} />} 
                                            label={<Typography variant={isMobile ? "caption" : "body2"}>White</Typography>} 
                                        />
                                        <FormControlLabel 
                                            control={<Checkbox disabled={!authenticated} checked={blackGames} onChange={e => { setBlackGames(e.target.checked); }} size={isMobile ? "small" : "medium"} />} 
                                            label={<Typography variant={isMobile ? "caption" : "body2"}>Black</Typography>} 
                                        />
                                        {!isMobile && <FormControlLabel control={<Checkbox disabled={!authenticated} onChange={e => { setIncludeGamesOfSameName(e.target.checked); }} />} label="Similar names" />}
                                        {isAdmin && !isMobile && <FormControlLabel control={<Checkbox disabled={!isAdmin} onChange={e => { setR(e.target.checked); }} />} label="R" />}
                                        {isAdmin && !isMobile && <FormControlLabel control={<Checkbox disabled={!isAdmin} onChange={e => { setU(e.target.checked); }} />} label="U" />}
                                        {/*<FormControlLabel control={<Checkbox checked={eventFideRated} size="small" onChange={async (e) => { await setEventFideRated(e.target.checked); await setOpenEventFideRatedAlert(e.target.checked); }} />} label="FIDE Rated" />*/}
                                        {/*<FormControlLabel control={<Checkbox checked={eventNormPossible} size="small" onChange={async (e) => { await setEventNormPossible(e.target.checked) }} />} label="Norm Possible" />*/}
                                    </FormGroup>
                                </FormControl>
                            }
                        </Grid>
                        {allGames.length > 0 && authenticated &&
                            <Grid item xs={4} lg={2} justifyContent="flex-end">
                                <LoadingButton
                                    fullWidth
                                    size={isMobile ? "small" : "medium"}
                                    onClick={async (e) => { await setDownloading(true); await refreshPlayerGames(e, idType, id, includeGamesOfSameName, excludeBlitzGames, whiteGames, blackGames, r, u); }}
                                    loading={downloading}
                                    loadingIndicator={isMobile ? "..." : "Refreshing..."}
                                    variant="contained"
                                    color="warning"
                                    endIcon={!isMobile && <RefreshIcon />}
                                    disabled={!whiteGames && !blackGames}
                                >
                                    {isMobile ? <RefreshIcon /> : "Refresh"}
                                </LoadingButton>
                            </Grid>
                        }
                        {allGames.length > 0 && authenticated &&
                            <Grid item xs={4} lg={2} justifyContent="flex-end">
                                <LoadingButton
                                    fullWidth
                                    size={isMobile ? "small" : "medium"}
                                    onClick={async (e) => { await setDownloading(true); await downloadPGN(e, idType, id, includeGamesOfSameName, excludeBlitzGames, whiteGames, blackGames); }}
                                    loading={downloading}
                                    loadingIndicator={isMobile ? "..." : "Downloading..."}
                                    variant="contained"
                                    endIcon={!isMobile && <CloudDownloadIcon />}
                                    disabled={!whiteGames && !blackGames}
                                >
                                    {isMobile ? <CloudDownloadIcon /> : "Download"}
                                </LoadingButton>
                            </Grid>
                        }
                        {allGames.length > 0 && authenticated && isMobile &&
                            <Grid item xs={4} justifyContent="flex-end">
                                <LoadingButton
                                    fullWidth
                                    size="small"
                                    onClick={async (e) => { await setDownloading(true); await emailPGN(e, idType, playerId, includeGamesOfSameName, excludeBlitzGames, whiteGames, blackGames); }}
                                    loading={downloading}
                                    loadingIndicator="..."
                                    variant="contained"
                                    color="secondary"
                                    disabled={!whiteGames && !blackGames}
                                >
                                    <AttachEmailIcon />
                                </LoadingButton>
                            </Grid>
                        }
                        {/*{games.length > 0 && !authenticated &&*/}
                        {/*    <Grid item xs={12} lg={4} justifyContent="flex-end">*/}
                        {/*        <Button fullWidth color="secondary" variant="contained" component={Link} to={{ pathname: loginPath, search: '?returnUrl=' + encodedReturnUrl }}>*/}
                        {/*            Login to View & Download Games*/}
                        {/*        </Button>*/}
                        {/*    </Grid>*/}
                        {/*}*/}

                        {/*{games.length > 0 && !authenticated &&*/}
                        {/*    <Grid item xs={12} lg={4} justifyContent="flex-end">*/}
                        {/*        <Button fullWidth color="secondary" variant="contained" component={Link} to={'/Identity/Account/Register?returnUrl=/authentication/login'}>*/}
                        {/*            No Account? Register*/}
                        {/*        </Button>*/}
                        {/*    </Grid>*/}
                        {/*}*/}

                        {waiting &&
                            <Grid container xs={12}>
                                <div style={{ zIndex: 999, position: 'fixed', top: '30%', left: '50%' }}>
                                    <span> <ThreeDots ariaLabel="waiting " color="#00BFFF" /></span>
                                </div>
                            </Grid>
                        }
                        {games.length > 0 &&
                            <Grid item xs={12}>
                                <CacheProvider value={muiCache}>
                                    <ThemeProvider theme={theme}>
                                        <MUIDataTable
                                            title={
                                                <Box sx={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', alignItems: isMobile ? 'flex-start' : 'center', gap: 1 }}>
                                                    <FormLabel sx={{ color: statusColor, fontSize: isMobile ? '11px' : '14px' }}>{status}</FormLabel>
                                                    {isMobile && games.length > 0 && (
                                                        <Typography variant="caption" color="text.secondary">
                                                            Tap a row to expand details
                                                        </Typography>
                                                    )}
                                                </Box>
                                            }
                                            data={games}
                                            columns={columns}
                                            options={options}
                                            components={components}
                                        />
                                    </ThemeProvider>
                                </CacheProvider>
                            </Grid>
                        }

                        <Grid container xs={12}>
                            {/*<div>*/}
                            <Modal style={{
                                //"width": "600",
                                //"height": "600",
                                "position": "fixed",
                                /*"top": "5%",*/
                                //"left": "50%",
                                //"transform": "translate(-50%, -50%)",
                                "bgcolor": "background.paper",
                                /*"border": "2px solid #000",*/
                                "boxShadow": "24",
                                "p": "4",
                                "alignItems": "center",
                                "justifyContent": "center",
                                display: 'flex',
                            }}
                                open={open}
                                onClose={handleClose}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                            >
                                <Box style={{ "backgroundColor": "white", "padding": "10px" }}>
                                    <div sytle={{ "alignItems": "right" }}>
                                        <button className="btn btn-warning" onClick={handleClose}>Close</button>
                                    </div>
                                    <div>
                                        <PGNViewer pgn={gamePGNString} key={gameKey} size={400} />
                                    </div>
                                </Box>
                            </Modal>



                            {/*</div>*/}
                        </Grid>

                        <Grid container xs={12}>
                            <Dialog open={openErrorDialog} onClose={handleCloseErrorDialog}>
                                <DialogTitle id="alert-dialog-title">Error</DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-eventDescription">
                                        {status}
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    {/*<Link to="/SupporterDonate">*/}
                                    {/*    <Button variant='contained'>Support MetaDB</Button>*/}
                                    {/*</Link>*/}
                                    <Button variant='contained' onClick={handleCloseErrorDialog} autoFocus>
                                        OK
                                    </Button>
                                </DialogActions>
                            </Dialog>
                        </Grid>

                        {/* Email PGN Dialog */}
                        <Dialog open={emailDialogOpen} onClose={handleCloseEmailDialog}>
                            <DialogTitle>
                                {emailSending ? 'Sending Email...' : (emailResult.success ? 'Email Sent!' : 'Email Failed')}
                            </DialogTitle>
                            <DialogContent>
                                {emailSending ? (
                                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 2 }}>
                                        <ThreeDots ariaLabel="sending" color="#00BFFF" height={50} width={50} />
                                        <Typography variant="body2" sx={{ mt: 2 }}>Sending PGN to your email...</Typography>
                                    </Box>
                                ) : (
                                    <Box sx={{ py: 1 }}>
                                        <DialogContentText>
                                            {emailResult.message}
                                        </DialogContentText>
                                        {emailResult.success && emailResult.email && (
                                            <Typography variant="body2" sx={{ mt: 1, fontWeight: 500 }}>
                                                Sent to: {emailResult.email}
                                            </Typography>
                                        )}
                                    </Box>
                                )}
                            </DialogContent>
                            <DialogActions>
                                <Button 
                                    variant='contained' 
                                    onClick={handleCloseEmailDialog} 
                                    disabled={emailSending}
                                    color={emailResult.success ? 'primary' : 'error'}
                                >
                                    {emailSending ? 'Please wait...' : 'OK'}
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </Grid>
                </Box>
            }
        </div>

    )
}